<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <a @click="openPage()">open link</a>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'linkPrivy',
  data: function () {
    return {
      linkData: ''
    }
  },
  methods: {
    openPage (event) {
      // this.$router.push(event)
      var test = window.open()
      test.location = 'https://sandbox.privy.id/'
    },
    fetchData() {
      // window.open('https://sandbox.privy.id/', '_blank')
      // this.linkData = localStorage.getItem('url_privyID')
      // this.linkData = 'https://sandbox.privy.id/'
    }
  },
  created () {
    this.fetchData()
  }
}
</script>